export default "__VITE_ASSET__BXsDUdma__"